import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    scoreMsg: null,
 };

export const scoreMsgSlice = createSlice({
    name: 'scoreMsg',
    initialState,
    reducers: {
        setScoreMsg(state, action) {
            state.scoreMsg = action.payload;
        },
    }
});

export default scoreMsgSlice;